import styles from './index.less';

import React, { useEffect, useState } from 'react';
import { history } from 'umi';
import { Table, Tag, message } from 'antd';
import { getUserDetail } from '@/services/athena';

const RENEW = {
  1: {
    text: '是',
    color: 'green',
  },
  2: {
    text: '否',
    color: 'red',
  },
};

const MemberDetails = (props) => {
  const { tenantId } = props;
  const [coachAdd, setCoachAdd] = useState(null);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
  });
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const { coachAdd } = history.location.query || {};
    if (coachAdd) {
      const boolCoachAdd = JSON.parse(coachAdd);
      setCoachAdd(boolCoachAdd);
    } else {
      setCoachAdd(null);
    }
  }, [history]);

  useEffect(() => {
    initUserDetail(pageData);
  }, [tenantId, coachAdd]);

  const initUserDetail = (pageData) => {
    if (!tenantId) {
      return;
    }
    const params = {
      requestData: { tenantId, coachAdd },
      page: pageData,
    };
    getUserDetail(params).then((res) => {
      if (res.code !== '00000') {
        message.error(res.msg);
        return;
      }
      setPageData({
        ...pageData,
        count: res?.page?.count,
      });
      setTableData(res.data || []);
    });
  };

  const handlerPage = (page) => {
    const pages = {
      currentPage: page.current,
      pageSize: page.pageSize,
    };
    setPageData({ ...pageData, ...pages });
    initUserDetail(pages);
  };

  const columns = [
    {
      title: '用户ID',
      key: 'userId',
      dataIndex: 'userId',
    },
    {
      title: '会员昵称',
      key: 'wxNickName',
      dataIndex: 'wxNickName',
      render: (text, record) => (
        <a
          href={`/user/record?id=${record.userId}&phone=${record.phone}`}
          target="_blank"
          rel="noreferrer"
        >
          {text}
        </a>
      ),
    },
    // {
    //   title: '培训期会员',
    //   key: 'protectUser',
    //   dataIndex: 'protectUser',
    //   render: (value) => PROTECTUSER[value] && <Tag>{PROTECTUSER[value]}</Tag>,
    // },
    {
      title: '开通自动续费',
      key: 'renew',
      dataIndex: 'renew',
      render: (value) => (
        <Tag color={RENEW[value].color}>{RENEW[value].text}</Tag>
      ),
    },
    // {
    //   title: '签约类型',
    //   key: 'vipType',
    //   dataIndex: 'vipType',
    //   render: (values) =>
    //     values
    //       ?.split(',')
    //       .map((value, index) => <Tag key={index}>{value}</Tag>),
    // },
    {
      title: ' 会员身份标识',
      key: 'membershipNameList',
      dataIndex: 'membershipNameList',
      render: (value) =>
        value.map((value, index) => <Tag key={index}>{value}</Tag>),
    },
    {
      title: '家庭卡人数',
      key: 'familyUserNum',
      dataIndex: 'familyUserNum',
    },
    {
      title: '累计支付金额/元',
      key: 'paidAmountTotalYuan',
      dataIndex: 'paidAmountTotalYuan',
    },
    {
      title: '累计完课次数',
      key: 'completedClassNum',
      dataIndex: 'completedClassNum',
    },
    {
      title: '入镜指导完课',
      key: 'completedXplanNum',
      dataIndex: 'completedXplanNum',
    },
      {
      title: 'SP完课',
      key: 'completedSpClassNum',
      dataIndex: 'completedSpClassNum',
    },
    {
      title: '所属教练',
      key: 'coachName',
      dataIndex: 'coachName',
    },
    {
      title: '绑定方式',
      key: 'bdTypeName',
      dataIndex: 'bdTypeName',
    },
  ];

  return (
    <div className={styles.alignRight}>
      {/* <Radio.Group
        value={coachAdd}
        onChange={({ target }) => {
          setCoachAdd(target.value);
          setPageData({
            ...pageData,
            currentPage: 1,
          });
        }}
      >
        <Radio value={null}>全部会员</Radio>
        <Radio value={false}>平台会员</Radio>
        <Radio value={true}>Lite会员</Radio>
      </Radio.Group> */}
      <Table
        rowKey="userId"
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 'max-content' }}
        pagination={{
          total: pageData.count,
          current: pageData.currentPage,
          pageSize: pageData.pageSize,
          showTotal: (total, range) =>
            `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
        }}
        onChange={handlerPage}
      />
    </div>
  );
};

export default MemberDetails;
